import { type TagWithDate } from '../model'
import { isEmpty } from './isEmpty'

export function generateTags(description: string): string[] {
  const matches = description.match(/#\p{L}+/gu) ?? []
  return matches.map((m) => m.slice(1).toLowerCase())
}

export function findLatestTag(tags: TagWithDate[] = []): TagWithDate | undefined {
  if (isEmpty(tags)) return
  return tags.reduce<TagWithDate | undefined>((latest, current) => {
    if (!latest) return current
    return current.timestamp > latest.timestamp ? current : latest
  }, undefined)
}
